export default __webpack_public_path__ + "static/media/Autumn_s Passing.af88d33c.png";